import { U21Themes } from 'app/shared/u21-ui/components';
import loadingLightGif from 'app/shared/gif/loading-ai-light.gif';
import loadingDarkGif from 'app/shared/gif/loading-ai-dark.gif';
import { useTheme } from '@mui/styles';
import styled from 'styled-components';
import { Paper } from '@mui/material';

export const AILoading = () => {
  const { palette } = useTheme();
  return (
    <GraphicContainer>
      <Img
        src={
          palette.mode === U21Themes.LIGHT ? loadingLightGif : loadingDarkGif
        }
        alt="Loading"
      />
    </GraphicContainer>
  );
};

const GraphicContainer = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 16px;
`;

const Img = styled.img`
  height: 40px;
  object-fit: contain;
`;
